import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

import accountManagementRouter from '@/router/modules/account-management';
import dataRouter from '@/router/modules/data';
import financialManagementRouter from '@/router/modules/financial-management';
import orderManagerRouter from '@/router/modules/order-management';
import resultRouter from '@/router/modules/result';
import systemManagerRouter from '@/router/modules/system-management';
import userRouter from '@/router/modules/user';
import warrantyRouter from '@/router/modules/warranty';
import { defaultRoute } from '@/utils/route';

const routes: RouteRecordRaw[] = [
  ...resultRouter,
  ...userRouter,
  ...dataRouter,
  ...orderManagerRouter,
  ...systemManagerRouter,
  ...accountManagementRouter,
  ...financialManagementRouter,
  ...warrantyRouter,
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/login/index.vue'),
  },
  {
    path: '/reset',
    name: 'reset',
    meta: {
      title: '重置密码',
    },
    component: () => import('@/pages/login/reset.vue'),
  },
  {
    path: '/',
    redirect: defaultRoute.path,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/pages/result/result-404.vue'),
    meta: {
      title: '404',
      hidden: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({
    el: '#app',
    top: 0,
    behavior: 'smooth',
  }),
});

export const getActive = (maxLevel = 3): string => {
  // 非组件内调用必须通过Router实例获取当前路由
  const route = router.currentRoute.value;

  if (!route.path) {
    return '';
  }

  return route.path
    .split('/')
    .filter((_item: string, index: number) => index <= maxLevel && index > 0)
    .map((item: string) => `/${item}`)
    .join('');
};

export default router;
